export default __webpack_public_path__ + "static/media/star-filled.e4f2387d.svg";